import React, { useCallback } from 'react';
import pt from 'prop-types';

import { Field } from 'components/form';

import withWidget from './with-widget';

function SwellRadio({ value, onChange, field }) {
  const onChangeField = useCallback(
    (event, value) => {
      onChange(event, Number(value));
    },
    [onChange],
  );

  return (
    <Field
      type="radio"
      label={field.label}
      options={field.params.options}
      checked={value}
      onChange={onChangeField}
      hint={field.description}
    />
  );
}

SwellRadio.propTypes = {
  value: pt.string,
  field: pt.object,
  onChange: pt.func,
};

export default withWidget(SwellRadio);
